module.exports = __webpack_public_path__ + "static/media/system_c.efccbf94.gif";